export default "__VITE_ASSET__OwctddI4__"